/* ============================================================
   FORMULA 21 — PDP v2 interactions
   Scoped to .f21pdp sections. Idempotent; re-runs on
   shopify:section:load so it works inside the Theme Editor.
   Features:
     • scroll reveal (.reveal -> .is-in)
     • count-up numbers ([data-f21-countup])
     • ingredient selector ([data-f21-ingredients])
     • zoom modal ([data-f21-zoom-trigger] / [data-f21-zoom-target])
     • sticky buy bar ([data-f21-sticky]) show/hide + plan mirror
     • smooth-scroll for [data-f21-scroll] (e.g. "Shop" -> #f21-offer)
     • offer plan pub/sub (window.F21.selectPlan / 'f21:plan' event)
   ============================================================ */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bound = '__f21bound';

  /* ---------------- Scroll reveal ---------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.f21pdp .reveal:not(.is-in)');
    if (!els.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Safety net for capture/print contexts.
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 1200);
  }

  /* ---------------- Count-up numbers ----------------
     <span data-f21-countup="161" data-f21-prefix="$" data-f21-suffix="/mo"
           data-f21-decimals="0">$161/mo</span>                                  */
  function runCountUp(el) {
    if (el[bound]) return; el[bound] = true;
    var target = parseFloat(el.getAttribute('data-f21-countup'));
    if (isNaN(target)) return;
    var prefix = el.getAttribute('data-f21-prefix') || '';
    var suffix = el.getAttribute('data-f21-suffix') || '';
    var decimals = parseInt(el.getAttribute('data-f21-decimals') || '0', 10);
    var grouped = el.getAttribute('data-f21-group') === 'true';
    function render(v) {
      var n = v.toFixed(decimals);
      if (grouped) {
        var parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        n = parts.join('.');
      }
      el.textContent = prefix + n + suffix;
    }
    if (REDUCE) { render(target); return; }
    var dur = 1100, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3); // out-cubic
      render(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCountUp(root) {
    var els = (root || document).querySelectorAll('.f21pdp [data-f21-countup]');
    if (!els.length) return;
    if (REDUCE || !('IntersectionObserver' in window)) { els.forEach(runCountUp); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { runCountUp(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Ingredient selector ----------------
     <div data-f21-ingredients>
       <button data-f21-ing-btn data-index="0">…</button> …
       <div data-f21-ing-detail data-index="0">…</div> …
     </div>                                                                      */
  function initIngredients(root) {
    var groups = (root || document).querySelectorAll('.f21pdp [data-f21-ingredients]');
    groups.forEach(function (group) {
      if (group[bound]) return; group[bound] = true;
      var btns = group.querySelectorAll('[data-f21-ing-btn]');
      var details = group.querySelectorAll('[data-f21-ing-detail]');
      function select(idx) {
        btns.forEach(function (b) { b.classList.toggle('v2-ing__item--active', b.getAttribute('data-index') === idx); });
        details.forEach(function (d) {
          var on = d.getAttribute('data-index') === idx;
          d.classList.toggle('is-active', on);
          d.hidden = !on;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { select(b.getAttribute('data-index')); });
      });
      select('0');
    });
  }

  /* ---------------- Zoom modal ----------------
     trigger: [data-f21-zoom-trigger="targetId"]
     target:  <div id="targetId" data-f21-zoom-target> … </div>                  */
  function initZoom(root) {
    var triggers = (root || document).querySelectorAll('.f21pdp [data-f21-zoom-trigger]');
    triggers.forEach(function (trigger) {
      if (trigger[bound]) return; trigger[bound] = true;
      var id = trigger.getAttribute('data-f21-zoom-trigger');
      var target = document.getElementById(id);
      if (!target) return;
      function open() {
        target.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        target.setAttribute('aria-hidden', 'false');
      }
      function close() {
        target.classList.remove('is-open');
        document.body.style.overflow = '';
        target.setAttribute('aria-hidden', 'true');
      }
      trigger.addEventListener('click', open);
      target.addEventListener('click', function (e) {
        if (e.target === target || e.target.hasAttribute('data-f21-zoom-close')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && target.classList.contains('is-open')) close();
      });
    });
  }

  /* ---------------- Smooth scroll ---------------- */
  function initScroll(root) {
    var links = (root || document).querySelectorAll('.f21pdp [data-f21-scroll]');
    links.forEach(function (link) {
      if (link[bound]) return; link[bound] = true;
      link.addEventListener('click', function (e) {
        var sel = link.getAttribute('data-f21-scroll') || '#f21-offer';
        var el = document.querySelector(sel);
        if (!el) return;
        e.preventDefault();
        var top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: REDUCE ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------------- Offer plan pub/sub ---------------- */
  window.F21 = window.F21 || {};
  window.F21.plan = window.F21.plan || null;
  window.F21.selectPlan = function (plan) {
    window.F21.plan = plan; // { id, label, price (formatted), priceRaw }
    document.dispatchEvent(new CustomEvent('f21:plan', { detail: plan }));
  };

  /* ---------------- Sticky buy bar ---------------- */
  function initSticky(root) {
    var bar = document.querySelector('[data-f21-sticky]');
    if (!bar || bar[bound]) return; bar[bound] = true;
    // Hoist the wrapper to <body> so the fixed bar escapes section stacking contexts.
    var wrap = bar.closest('[data-f21-stickywrap]') || bar;
    if (wrap.parentElement !== document.body) document.body.appendChild(wrap);

    function onScroll() {
      var docH = document.documentElement.scrollHeight;
      var y = window.scrollY;
      var show = y > 760 && y < (docH - window.innerHeight - 320);
      bar.classList.toggle('sticky-bar--visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mirror the selected plan's price/label into the bar.
    var nameEl = bar.querySelector('[data-f21-sticky-name]');
    var priceEl = bar.querySelector('[data-f21-sticky-price]');
    document.addEventListener('f21:plan', function (e) {
      var p = e.detail || {};
      if (nameEl && p.label) nameEl.textContent = 'Formula 21 · ' + p.label;
      if (priceEl && p.price) priceEl.textContent = p.price;
    });
  }

  /* ---------------- Boot ---------------- */
  function init(root) {
    initReveal(root);
    initCountUp(root);
    initIngredients(root);
    initZoom(root);
    initScroll(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
